import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getSystemFlags = api(async function getSystemFlags() {
    return query(
        gql`
            query getSystemFlags {
                getSystemFlags {
                    hubspotDisabled
                }
            }
        `,
        {},
        { returns: "getSystemFlags" }
    )
})
